import { RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { renderToString2kyj9dlz89tdi as renderToString } from '../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../strings.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { listOfNotNull2woi2boe01ub4 as listOfNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderToString_0(_this__u8e3s4, range, size) {
  size = size === VOID ? RenderSize_Abbreviation_getInstance() : size;
  return range.endInclusive_1 == null ? _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).dateRangeOnwards_e67e9b_k$(renderToString(range.start_1, size)) : renderToString(range.start_1, size) + ' - ' + renderToString(ensureNotNull(range.endInclusive_1), size);
}
function renderToString_1(_this__u8e3s4, size) {
  size = size === VOID ? RenderSize_Abbreviation_getInstance() : size;
  return replace(replace(replace(renderToString(_this__u8e3s4.get_firstDay_u4rr11_k$(), size), '1', ''), ' ,', ','), '  ', ' ');
}
function renderToString_2(_this__u8e3s4) {
  // Inline function 'kotlin.takeUnless' call
  var this_0 = _this__u8e3s4.get_years_j1r3xp_k$();
  var tmp;
  if (!(this_0 === 0)) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = '' + tmp0_safe_receiver + ' years';
  }
  var tmp_1 = tmp_0;
  // Inline function 'kotlin.takeUnless' call
  var this_1 = _this__u8e3s4.get_months_gqmrjw_k$();
  var tmp_2;
  if (!(this_1 === 0)) {
    tmp_2 = this_1;
  } else {
    tmp_2 = null;
  }
  var tmp1_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp1_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = '' + tmp1_safe_receiver + ' months';
  }
  var tmp_4 = tmp_3;
  // Inline function 'kotlin.takeUnless' call
  var this_2 = _this__u8e3s4.days_1;
  var tmp_5;
  if (!(this_2 === 0)) {
    tmp_5 = this_2;
  } else {
    tmp_5 = null;
  }
  var tmp2_safe_receiver = tmp_5;
  var tmp_6;
  if (tmp2_safe_receiver == null) {
    tmp_6 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_6 = '' + tmp2_safe_receiver + ' days';
  }
  return joinToString(listOfNotNull([tmp_1, tmp_4, tmp_6]), ' ');
}
//region block: exports
export {
  renderToString_1 as renderToString1pjqj7ffu15sz,
  renderToString_2 as renderToString5s2ibn3uk3ah,
  renderToString_0 as renderToString1uchiuvkjsib7,
};
//endregion

//# sourceMappingURL=daterender.mjs.map
